import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';
import './TextStyles.css';
import './DisclosureArrow.css';

class WorksBlock extends Component {
    constructor(props) {
        super(props);
        const initialShowingDetailsState = localStorage.getItem(this.getKey()) || "false";
        this.state = { isShowingDetails: JSON.parse(initialShowingDetailsState) };
        
    }
    
    getKey() {
        const {
            title,
            company,
            startDate,
            endDate,
        } = this.props;
        return `workBlock-${title}-${company}-${startDate}-${endDate}`.replace(/[^0-9a-zA-Z]/g, '_');
    }

    onDisclosureClicked() {
        const newShowingDetailsState = !this.state.isShowingDetails;
        
        localStorage.setItem(this.getKey(), JSON.stringify(newShowingDetailsState));
        this.setState(
            {
                isShowingDetails: newShowingDetailsState
            }
        )
    }

    render() {
        const {
            title,
            company,
            companyUrl,
            startDate,
            endDate,
            location,
            backgroundColor,
            showDivider
        } = this.props;
        const workRangeStyle = {
            marginLeft: '3em',
            marginRight: '1em', 
            whiteSpace: 'nowrap',
            fontFamily: 'Verdana',
            fontSize: 'small',
            fontVariant: 'small-caps',
            textAlign: 'right'
        };
        const detailViewId = `workexp-detail-${title.replace(/[^0-9a-zA-Z]/g, '_')}-${startDate.replace(/[^0-9a-zA-Z]/g, '_')}-to-${endDate.replace(/[^0-9a-zA-Z]/g, '_')}`;
        
        const details = this.state.isShowingDetails === true ?
            (
                <div>
                    {this.props.children}
                </div>
            ) : undefined;
        const disclosureAngleDirection = this.state.isShowingDetails === true ? 'angle-down' : 'angle-up';
        const dividerElement = showDivider !== false ? ( <hr /> ) : undefined;
        return (
            <div style={{ backgroundColor }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span className='topicItemHeaderText'>{title}</span>
                    <span style={workRangeStyle}>{startDate} to {endDate} <FontAwesome onClick={this.onDisclosureClicked.bind(this)} name={disclosureAngleDirection} className='DisclosureArrow' /></span>
                </div>
                <div id={detailViewId}>
                    <p><a href={companyUrl} target="_blank">{company}</a>, {location}</p>
                    { details }
                </div>
                { dividerElement }
            </div>
        );
    }
}

export default WorksBlock;



// WEBPACK FOOTER //
// ./src/WorkBlock.js